import { ApiError } from "@vana/core";

export class ListPendingConfirmationError extends ApiError {}

export class ListZonesError extends ApiError {}

export class ListGeoCatalogError extends ApiError {}

export class UpdateAddressError extends ApiError {}

export class AddAddressError extends ApiError {}

export class ConfirmDeliveryError extends ApiError {}

export class ListContactLogsError extends ApiError {}

export class LogContactError extends ApiError {}
